import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';

export const NEW_STUDENT = {
  [Fields.Id]: '0',
  [Fields.GradeId]: '00',
  [Fields.IdSeed]: 0,
  [Fields.Exceptions]: {
    [Fields.IsDirectCertified]: false,
    [Fields.IsFoster]: false,
    [Fields.IsKinGap]: false,
    [Fields.IsEmancipatedMinor]: false,
    [Fields.IsHeadStart]: false,
    [Fields.HMRCategory]: 0,
    [Fields.IsExtendedBenefits]: false,
    [Fields.IsExtendedBenefitsHasChanged]: false,
    [Fields.CaseNumber]: null,
    [Fields.CaseTypeId]: null,
  },
};

export const EMPTY_INCOME = {
  Freq1: -1,
  Freq2: -1,
  Freq3: -1,
  Freq4: -1,
  Income1: 0,
  Income2: 0,
  Income3: 0,
  Income4: 0,
};

export const MODIFY_BUTTON_TEXT = 'Continue';

export const VerifyAction = {
  DenyIncomplete: 0,
  DenyNoResponse: 1,
  HouseholdDeclined: 2,
  DirectlyVerified: 3,
  VerifyNoChange: 4,
};

export const VerificationStatusMessage = {
  H: 'Household Declined Benefits',
  V: 'Directly Verified',
  '1': 'Withdrawn - No Letter Sent',
  '2': 'No Change in Benefits',
  '3': 'Decrease Benefits - Free to Reduce',
  '4': 'Denied Over Income',
  '5': 'Denied - No longer in Category',
  '6': 'Increase Benefits due to Income',
  '7': 'Increase Benefits due to Categorical Change',
  '8': 'Denied as Incomplete',
  '9': 'Denied as No Response',
  S: 'Selected for Verification',
};

export const SecondReviewResultEnumeration = {
  NoChange: 1,
  IncompleteApplicationError: 2,
  CategoricalEligibilityError: 3,
  GrossIncomeCalculationError: 4,
  OtherError: 5,
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/helpers/Constants.js